/* src/app/components/HeaderTable/index.js */

import React from 'react';
import PropTypes from 'prop-types';
import { map, omitBy, upperFirst, isEmpty, find, remove } from 'lodash';

import { withStyles } from '@material-ui/core/styles';
import {
  IconButton,
  Table, TableBody, TableCell, TableHead, TableRow, TableSortLabel,
  Tooltip,
  Typography,
  Checkbox,
} from '@material-ui/core';
import { KeyboardArrowLeft, KeyboardArrowRight } from '@material-ui/icons';

import LoadingIndicator from '../LoadingIndicator';

import { colors } from '../../../config/constants/styles';
import styles from './styles';

class HeaderTable extends React.Component {
  constructor(props) {
    super(props);
    const { classes, start, end, loading, data } = props;
    this.state = {
      start,
      end,
      loading,
      headers: isEmpty(data) ? [] : Object.keys(data[0]),
      values: data,
      selected: '',
      sortDirection: 'asc',
      colored: props.colored,
      checkedArray: [],
      checkedAll: false,
    };
    this.cellClass = () => classes.cell;
  }

  componentWillReceiveProps({ start, end, loading, data, colored }) {
    this.setState({
      start,
      end,
      loading,
      headers: isEmpty(data) ? [] : Object.keys(data[0]),
      values: data,
      colored,
    });
  }

  _sort(header) {
    const { sortDirection } = this.state;
    this.props.onSort({ field: header, direction: sortDirection === 'asc' ? 1 : -1 });
    this.setState({
      selected: header,
      sortDirection: sortDirection === 'asc' ? 'desc' : 'asc',
    });
  }

  onCheck(d) {
    const { checkedArray } = this.state;
    let temp = checkedArray;
    if (!isEmpty(find(temp, i => i._id == d._id))) {
      remove(temp, i => i._id == d._id)
    } else {
      temp.push(d);
    }
    this.setState({ checkedArray: temp, checkedAll: false });
    this.props.onCheckRow(d)
  }

  renderHeader() {
    const { classes, Action, sortEnabled, data } = this.props;
    const { headers, selected, sortDirection, checkedAll, checkedArray} = this.state;
    // const last = headers.length - 1;

    return (
      <TableHead>
        <TableRow className={classes.header}>
          {
            this.props.showCheckbox && (
            <TableCell padding="checkbox">
              <Checkbox
                color="primary"
                // indeterminate={numSelected > 0 && numSelected < rowCount}
                checked={checkedAll}
                onChange={event => {
                  this.setState({
                    checkedAll: event.target.checked,
                    checkedArray: event.target.checked ? data.slice() : []
                  }, () => this.props.onCheckAll(this.state.checkedArray));
                }}
              />
            </TableCell>)
          }
          {map(headers, v => {
            if (!v.startsWith('_')) {
              return (
                <TableCell className={this.cellClass()} key={v} padding="dense">
                  {sortEnabled ? (
                    <Tooltip title="Sort">
                      <TableSortLabel
                        active={v === selected}
                        direction={sortDirection}
                        onClick={() => this._sort(v)}
                      >
                        {upperFirst(v)}
                      </TableSortLabel>
                    </Tooltip>
                  ) : upperFirst(v)}
                </TableCell>
              );
            }
            return null;
          })}
          {Action && <TableCell className={this.cellClass()} padding="dense" />}
        </TableRow>
      </TableHead>
    );
  }

  renderRow(datum, action, classes, hover, onRowClick, colored) {
    const { checkedArray } = this.state;
    const noID = omitBy(datum, (v, k) => k.startsWith('_'));
    const headers = Object.keys(noID);
    const fields = Object.values(noID);
    const last = fields.length - 1;
    return (
      <TableRow
        key={datum._id}
        onClick={() => onRowClick(datum)}
        hover={hover}
        style={{ backgroundColor: (colored && datum._color !== '') ? colors[datum._color] : '' }}
      >
        {
          this.props.showCheckbox && (
          <TableCell padding="checkbox">
            <Checkbox
              color="primary"
              // indeterminate={numSelected > 0 && numSelected < rowCount}
              checked={!isEmpty(find(checkedArray, i => i._id === datum._id))}
              onChange={() => {
                this.onCheck(datum);
              }}
              onClick={e => {
                e.stopPropagation();
              }}
            />
          </TableCell>)
        }
        {map(fields, (v, i) => (
          <TableCell key={headers[i]} className={this.cellClass(i === 0, i === last)} padding="dense">
            <Typography noWrap>
              {v}
            </Typography>
          </TableCell>
        ))}
        {action && (
          <TableCell className={classes.action}>
            {action(datum)}
          </TableCell>
        )}
      </TableRow>
    );
  }

  renderFooter() {
    const { classes, onNext, onPrev, count, label } = this.props;
    const { start, end } = this.state;

    return (
      <div className={classes.footer}>
        <IconButton disabled={start <= 1} onClick={onPrev}>
          <KeyboardArrowLeft />
        </IconButton>
        <Typography className={classes.pageText}>
          {start} - {end}
        </Typography>
        <IconButton onClick={onNext} disabled={end >= count}>
          <KeyboardArrowRight />
        </IconButton>
        <Typography className={classes.numRecords}>{count} {label}</Typography>
      </div>
    );
  }

  render() {
    const { header, paging, classes, hover, onRowClick, Action } = this.props;
    const { loading, values, colored } = this.state;
    return (
      <div className={classes.root}>
        <Table>
          {header && this.renderHeader()}
          <TableBody>
            {map(values, datum =>
              this.renderRow(datum, Action, classes, hover, onRowClick, colored))}
          </TableBody>
        </Table>
        {paging && this.renderFooter()}
        <LoadingIndicator loading={loading} />
      </div>
    );
  }
}

HeaderTable.propTypes = {
  data: PropTypes.array.isRequired,
  classes: PropTypes.object.isRequired,
  onRowClick: PropTypes.func,
  hover: PropTypes.bool,
  header: PropTypes.bool,
  Action: PropTypes.func,
  paging: PropTypes.bool,
  colored: PropTypes.bool,
  start: PropTypes.number,
  end: PropTypes.number,
  onNext: PropTypes.func,
  onPrev: PropTypes.func,
  loading: PropTypes.bool,
  count: PropTypes.string,
  label: PropTypes.string,
  onSort: PropTypes.func,
  sortEnabled: PropTypes.bool,
  showCheckbox: PropTypes.bool,
  onCheckRow: PropTypes.func,
  onCheckAll: PropTypes.func,
};

HeaderTable.defaultProps = {
  Action: null,
  hover: false,
  header: true,
  paging: false,
  loading: false,
  colored: false,
  start: -1,
  end: -1,
  count: '0',
  label: 'rows',
  onRowClick: () => {},
  onNext: () => {},
  onPrev: () => {},
  onSort: () => {},
  sortEnabled: false,
  showCheckbox: false,
  onCheckRow: () => {},
  onCheckAll: () => {}
};

export default withStyles(styles)(HeaderTable);



// WEBPACK FOOTER //
// ./src/app/components/HeaderTable/index.js